module.exports = __webpack_public_path__ + "static/media/Test35.8cf2c2d6.bmp";